import { render } from "./AppInputFile.vue?vue&type=template&id=2c9c0414&ts=true"
import script from "./AppInputFile.vue?vue&type=script&lang=ts"
export * from "./AppInputFile.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__